export default __webpack_public_path__ + "static/media/FurnitureItem7.7bda59ee.png";